import {
  PASSWORD_RESET_ROUTE,
  WALLET_DASHBOARD,
  WALLET_FORGOT_ROUTE,
  WALLET_LOGIN_ROUTE,
  WALLET_REGISTER_ROUTE,
  WALLET_ROUTE,
  WALLET_SETTINGS_ROUTE
} from './route-names'
import WalletView from '@/views/WalletView'
import Register from '@/components/wallet/Register'
import Login from '@/components/wallet/Login'
import RecoverPassword from '@/components/wallet/RecoverPassword'
import ResetPassword from '@/components/wallet/ResetPassword'
import Dashboard from '@/components/wallet/Dashboard'
import WalletSettings from '@/components/wallet/WalletSettings'

export const ALLOW_UNAUTHENTICATED_META_PROP = 'allowUnauthenticated'

const walletRoutes = [
  {
    path: '/wallet',
    name: WALLET_ROUTE,
    component: WalletView,
    redirect: 'wallet/login',
    children: [
      {
        path: 'login',
        name: WALLET_LOGIN_ROUTE,
        component: Login,
        meta: {
          [ALLOW_UNAUTHENTICATED_META_PROP]: true,
          segmentName: 'Wallet Login'
        }
      },
      {
        path: 'register',
        name: WALLET_REGISTER_ROUTE,
        component: Register,
        meta: {
          [ALLOW_UNAUTHENTICATED_META_PROP]: true,
          segmentName: 'Wallet Register'
        }
      },
      {
        path: 'recover',
        name: WALLET_FORGOT_ROUTE,
        component: RecoverPassword,
        meta: {
          [ALLOW_UNAUTHENTICATED_META_PROP]: true,
          segmentName: 'Forgot Password'
        }
      },
      {
        path: 'reset-password',
        name: PASSWORD_RESET_ROUTE,
        component: ResetPassword,
        meta: {
          [ALLOW_UNAUTHENTICATED_META_PROP]: true,
          segmentName: 'Reset Password'
        }
      },
      {
        path: 'dashboard',
        name: WALLET_DASHBOARD,
        component: Dashboard,
        meta: {
          segmentName: 'Wallet Dashboard'
        }
      },
      {
        path: 'settings',
        name: WALLET_SETTINGS_ROUTE,
        component: WalletSettings,
        meta: {
          segmentName: 'Wallet Settings'
        }
      }
    ]
  }
]

export { walletRoutes }
